import { Injectable } from '@angular/core';
import { SubscriptionBookingStatus } from '@platform-frontend/checkout-drop-in';
import { SerializedProductService } from '../product';
import { OneTimePurchase } from './model/one-time-purchase';
import { OneTimePurchaseDetails } from './model/one-time-purchase-details';
import { SerializedOneTimePurchase } from './model/serialized-one-time-purchase';
import { SerializedOneTimePurchaseDetails } from './model/serialized-one-time-purchase-details';
import { SerializedSubscription } from './model/serialized-subscription';
import { SerializedSubscriptionDetails } from './model/serialized-subscription-details';
import { Subscription } from './model/subscription';
import { SubscriptionDetails } from './model/subscription-details';

@Injectable({
  providedIn: 'root'
})
export class SerializedAssetService {
  constructor(private serializedProductService: SerializedProductService) {}

  deserializeSubscription<T = SubscriptionBookingStatus>(serializedSubscription: SerializedSubscription<T>): Subscription<T> {
    const serializedDetails = serializedSubscription.subscriptionDetails;
    return {
      ...serializedSubscription,
      product: this.serializedProductService.deserializeProduct(serializedSubscription.product),
      subscriptionDetails: this.deserializeSubscriptionDetails(serializedDetails)
    };
  }

  deserializeOneTimePurchase(serializedOneTimePurchase: SerializedOneTimePurchase): OneTimePurchase {
    const serializedDetails = serializedOneTimePurchase.oneTimePurchaseDetails;
    return {
      ...serializedOneTimePurchase,
      product: this.serializedProductService.deserializeProduct(serializedOneTimePurchase.product),
      oneTimePurchaseDetails: this.deserializeOneTimePurchaseDetails(serializedDetails)
    };
  }

  private deserializeOneTimePurchaseDetails(serializedDetails: SerializedOneTimePurchaseDetails): OneTimePurchaseDetails {
    return {
      ...serializedDetails,
      endOfTerm: serializedDetails.endOfTerm ? new Date(serializedDetails.endOfTerm) : null,
      purchaseDate: new Date(serializedDetails.purchaseDate),
      revokableUntil: serializedDetails.revokableUntil ? new Date(serializedDetails.revokableUntil) : null
    };
  }

  private deserializeSubscriptionDetails<T>(serializedDetails: SerializedSubscriptionDetails<T>): SubscriptionDetails<T> {
    return {
      ...serializedDetails,
      purchaseDate: new Date(serializedDetails.purchaseDate),
      revokableUntil: serializedDetails.revokableUntil ? new Date(serializedDetails.revokableUntil) : null,
      endOfPeriod: new Date(serializedDetails.endOfPeriod),
      endOfNoticePeriod: serializedDetails.endOfNoticePeriod ? new Date(serializedDetails.endOfNoticePeriod) : null,
      terminationDate: new Date(serializedDetails.terminationDate)
    };
  }
}
